import {NgModule}                       from '@angular/core';
import {Route, RouterModule}            from '@angular/router';
import {ApCroptypesOverviewComponent}   from './components/ap-croptypes.component';
import {PageMode}                       from '../ap-interface';
import {ApSubFarmsComponent}            from './components/ap-subfarms.component';
import {ApDocuRessourcesComponent}      from './components/ap-docu-ressources.component';
import {ApVarietiesOverviewComponent}   from './components/ap-varieties.component';
import {ApFertilizersOverviewComponent} from './components/ap-fertilizers.component';
import {ApPlantProtectionProductsComponent}    from './components/ap-plant-protection-products.component';
import {ApWorktypesOverviewComponent}   from './components/ap-worktypes.component';
import {ApUsersOverviewComponent}       from './components/users/ap-users-overview.component';
import {ApPermissionGuard}              from '../guards/ap-permission-guard.service';

const routes: Route[] = [
  {
    path: 'croptypes',
    component: ApCroptypesOverviewComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'subfarms',
    component: ApSubFarmsComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'docu-ressources',
    component: ApDocuRessourcesComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'users',
    component: ApUsersOverviewComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'varieties',
    component: ApVarietiesOverviewComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'fertilizers',
    component: ApFertilizersOverviewComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'plant-protections',
    component: ApPlantProtectionProductsComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'worktypes',
    component: ApWorktypesOverviewComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class ApBasedataRoutes {
}
